/**
 * 窗口内提示条控制器单例（浏览器接线，18c2b）。
 *
 * main.tsx 建一次（并把 show/clear 交给 notifyDelivery 的投递接线），
 * NotifyPopups 组件调同一个单例拿 activate/dismiss —— 同 swUpdate() 的分工。
 * 队列与超时在 ./notifyPopupState（可注入、可单测），这里只管单例与浏览器依赖。
 */
import { globalStore } from './global';
import { createNotifyPopupController, type NotifyPopupController } from './notifyPopupState';
import { browserAudioContextFactory, createNotifySound } from '~/push/notifySound';
import { openChat } from '~/nav/actions';
import { appRouter } from '~/nav/appRouter';

let conn: NotifyPopupController | undefined;

export function notifyPopups(): NotifyPopupController {
  if (!conn) {
    conn = createNotifyPopupController(globalStore(), {
      setTimer: (fn, ms) => {
        const id = window.setTimeout(fn, ms);
        return () => clearTimeout(id);
      },
      // 提示音现场合成，没有音频文件也就没有额外请求（见 push/notifySound）
      playSound: createNotifySound(browserAudioContextFactory()),
      openChat: (key) => openChat(appRouter(), key),
    });
  }
  return conn;
}
